export enum HubEvent {
  APPOINTMENT_UPDATED = "appointment-updated",
  APPOINTMENT_RESCHEDULED = "appointment-rescheduled",
  APPOINTMENT_CREATED = "appointment-created",
  APPOINTMENT_DELETED = "appointment-deleted",
  APPOINTMENT_CANCELED = "appointment-canceled",
  PROFILE_IMAGE_UPDATED = "profile-image-updated",
  TENANT_UPDATED = "tenant-updated",
  UI_SETTINGS_UPDATED = "ui-settings-updated"
}
